import fetch from "cross-fetch";
import { CMS_API_URL } from "../../config";
import {
  shouldFetchCircleSuggestions,
  shouldFetchSuggestion
} from "./selectors.js";
import * as ActionCreators from "./creators";
// Fetch content for a specific page and dispatch fecth for content blocks for page
export function fetchSuggestionsInCollection(
  collection,
  limit,
  offset,
  featured
) {
  return function(dispatch, getState) {
    if (
      !shouldFetchCircleSuggestions(getState(), collection, offset, featured)
    ) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingCircleSuggestions(collection, featured));
    let url = `${CMS_API_URL}/circlesuggestions?is_published=true&_sort=updated_at:DESC&collection_key=${collection}&_limit=${limit +
      1}&_start=${offset}`;
    if (featured) {
      url += `&featured=true`;
    }

    return fetch(url)
      .then(
        response => response.json(),
        error => {
          dispatch(
            ActionCreators.errorFetchingCircleSuggestions(
              "errors.circle_suggestions.fetch"
            )
          );
        }
      )
      .then(response => {
        let has_more = false;
        if (response.length > limit) {
          has_more = true;
          response = response.splice(0, limit);
        }

        dispatch(
          ActionCreators.fetchedCircleSuggestions(
            collection,
            response,
            limit,
            offset,
            featured,
            has_more
          )
        );
      });
  };
}

export function fetchSuggestionInCollection(collection, featured, id) {
  return function(dispatch, getState) {
    if (!shouldFetchSuggestion(getState(), collection, featured, id)) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingCircleSuggestions(collection, featured));
    let url = `${CMS_API_URL}/circlesuggestions/${id}`;

    return fetch(url)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingCircleSuggestions(error));
        }
      )
      .then(response => {
        dispatch(
          ActionCreators.fetchedCircleSuggestion(collection, response, featured)
        );
      });
  };
}
